var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ver_video",on:{"click":_vm.videoClick}},[_c('div',{attrs:{"id":"dplayer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }